// UI Theme
/* Con esta importacion solo se importan los estilos de los material-icons */
import 'material-icons/iconfont/filled.css';
import '@/styles/index.scss';
import {defineAsyncComponent, createApp} from 'vue';
import {sync} from 'vuex-router-sync';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import {getRolesNew} from '@/api/controller/main/main-controller';
import {setCookie} from '@/utils/cookies';
import {setupMsalInterceptor} from '@/utils/msal-interceptor';

import App from './App.vue';

import {routes, hooks, routerOptions} from './routes';

import authModule from '@/pages/_root/modules/auth/auth.module';
import enumsModule from '@/pages/_root/modules/enums/enums.module';
import unidadesModule from '@/pages/_root/modules/unidades/unidades.module';
import agruparModule from '@/pages/_root/modules/agrupar/agrupar.module';

import {loadStore, errorApi} from '@/utils/constants';
import {decryptData} from '@/utils/encryptionUtils';
import {
  createApplicationInsights,
  createMsal,
  createAuthorization,
  createRouter,
  createStore,
  createAxios,
  useDev,
  createToast,
  getAppConfig,
} from '@sttedra_ui/framework';

import Column from 'primevue/column';
import Tooltip from 'primevue/tooltip';

const Button = defineAsyncComponent(() => import('primevue/button'));
const dataTable = defineAsyncComponent(() => import('primevue/datatable'));
const Dialog = defineAsyncComponent(() => import('primevue/dialog'));
const DialogService = defineAsyncComponent(() => import('primevue/dialog'));
const Checkbox = defineAsyncComponent(() => import('primevue/checkbox'));
const Calendar = defineAsyncComponent(() => import('primevue/calendar'));
const Dropdown = defineAsyncComponent(() => import('primevue/dropdown'));
const InputText = defineAsyncComponent(() => import('primevue/inputtext'));
const InputNumber = defineAsyncComponent(() => import('primevue/inputnumber'));
const Divider = defineAsyncComponent(() => import('primevue/divider'));
const Toast = createToast();

// custom inputs components

const DropdownComun = defineAsyncComponent(() =>
  import('@/components/componentes-custom/DropdownComun.vue'),
);
const MultiSelectComun = defineAsyncComponent(() =>
  import('@/components/componentes-custom/MultiselectComun.vue'),
);
const MultiselectGroupComun = defineAsyncComponent(() =>
  import('@/components/componentes-custom/MultiselectGroupComun.vue'),
);
const DialogCommon = defineAsyncComponent(() =>
  import('@/components/modals-custom/DialogCommon.vue'),
);
const DialogCommonLeyends = defineAsyncComponent(() =>
  import('@/components/modals-custom/DialogCommonLeyends.vue'),
);
const CalendarComun = defineAsyncComponent(() =>
  import('@/components/componentes-custom/CalendarComun.vue'),
);
const PickListCommon = defineAsyncComponent(() =>
  import('@/components/componentes-custom/PickListCommon.vue'),
);
const InputMaskNumber = defineAsyncComponent(() =>
  import('@/components/componentes-custom/InputMaskNumber.vue'));
const DropdownGroupComun = defineAsyncComponent(() =>
  import('@/components/componentes-custom/DropdownGroupComun.vue'),
);
// (!) Show all STTEDRA logs
// useDev.showAll(); useDev.hideAll(); useDev.show('YOUR_REGEXP');
useDev.hideAll();
// #region Creation
const {
  applicationInsightsConfig,
  axiosConfig,
  isProduction,
  msalConfig,
  primeVueOptions,
} = getAppConfig();

const app = createApp(App);
const appInsights = createApplicationInsights(applicationInsightsConfig);
const axios = createAxios();

const msal = createMsal(msalConfig);
const authorization = createAuthorization();

const router = createRouter(routes, hooks, {routerOptions});
const store = createStore(isProduction);
store.registerModule('auth', authModule);
store.registerModule('enums', enumsModule);
store.registerModule('unidades', unidadesModule);
store.registerModule('agrupar', agruparModule);
// #endregion

// #region Mount
sync(store, router);

if (appInsights) {
  app.use(appInsights);
}

app.use(axios, axiosConfig);
app.use(store);
app.use(msal);

app.use(authorization, {api: async () => {
  return getRolesNew(store);
}});

app.use(router);
app.use(PrimeVue, primeVueOptions);
app.use(ConfirmationService);
app.use(Toast);
app.use(DialogService);

app.directive('tooltip', Tooltip);
app.component('ButtonPrime', Button);
app.component('Calendar', Calendar);
app.component('Checkbox', Checkbox);
app.component('Column', Column);
app.component('DataTable', dataTable);
app.component('DialogPrime', Dialog);
app.component('Dropdown', Dropdown);
app.component('InputNumber', InputNumber);
app.component('InputText', InputText);
app.component('InputMaskNumber', InputMaskNumber);
app.component('Divider', Divider);

// custom inputs components
app.component('DropdownComun', DropdownComun);
app.component('MultiSelectComun', MultiSelectComun);
app.component('MultiselectGroupComun', MultiselectGroupComun);
app.component('DialogCommon', DialogCommon);
app.component('DialogCommonLeyends', DialogCommonLeyends);
app.component('CalendarComun', CalendarComun);
app.component('PickListCommon', PickListCommon);
app.component('DropdownGroupComun', DropdownGroupComun);
let vm = null;

const initialData = async () => {
  setupMsalInterceptor();
  const encryptedData = localStorage.getItem('_config');
  if (encryptedData) {
    const userConfigData = JSON.parse(decryptData(encryptedData));
    store.commit('auth/setSaveDataUser', userConfigData);

    loadStore(store);
    const fechaExp = new Date().setDate(new Date().getDate() + 1);
    setCookie('auditLogin', fechaExp);
  }

  const adminData = JSON.parse(localStorage.getItem('actuarAdmin'));
  if (!adminData || new Date(adminData.fecha).getDate() !== new Date().getDate()) {
    localStorage.setItem('actuarAdmin', JSON.stringify({valor: false, fecha: new Date()}));
  }
};

router.isReady().then(async () => {
  if (errorApi) {
    router.push({
      name: 'FalloConexionView',
    });
  }
  if (!errorApi) {
    await initialData();
  }
  vm = app.mount('#' + VUE_APP_ID);
});
// #endregion
export {vm}; // window.sttedra._root.vm
